import {
    Router,
    useRouter,
    Container,
    CustomContainer,
} from "../../atoms/DependencyHelper";
import Checkbox from "../../atoms/checkBox/Checkbox";
import styles from "./AffordabilityFilterToggle.module.scss";
import PropTypes from 'prop-types';

const AffordabilityFilterToggle = (props) => {
    const handleCheck = (flag) => {
        props.handleCheck(flag)
    }

    return (
        <CustomContainer className={props.boxClass ? props.boxClass : styles["wrapper-checkbox"]}>
            <Checkbox
                isChecked={props.check}
                id={props.id}
                check={props.checkboxLabel}
                count="0"
                isBrand="false"
                handleCheck={handleCheck}
                checkBoxLabelStyling="brandLabelStyling"
            />
            {props.check && (
                <div className={styles["item-label"]}>
                    {props.checkboxSubtext}
                </div>
            )}

        </CustomContainer>
    )
};

AffordabilityFilterToggle.propTypes = {
    boxClass: PropTypes.string,
    checkboxLabel: PropTypes.string,
    checkboxSubtext: PropTypes.string,
    id: PropTypes.string,
    handleCheck: PropTypes.func,
    check: PropTypes.bool,
};

export default AffordabilityFilterToggle;
